import { Box, Button, CircularProgress, makeStyles } from '@material-ui/core';
import { PlaylistAdd } from '@material-ui/icons';
import React, { memo, useCallback, useMemo, useState } from 'react';
import { useDataProvider, useRecordContext, useTranslate } from 'react-admin';
import { useField } from 'react-final-form';
import keyBy from 'lodash/keyBy';
import clsx from 'clsx';
import resourceSlug from '../../../../../constant/resource-slug';

const QuickAction = ({ onChange, currencies }) => {
  const classes = useStyles();
  const t = useTranslate();
  const dataProvider = useDataProvider();
  const [adding, setAdding] = useState(false);
  const {
    input: { value: group },
  } = useField('group');
  const record = useRecordContext();

  const filters = useMemo(
    () => ({
      'groups.id||$in': group?.id,
      ...(!!record?.id && {
        skipBrandACL: true,
      }),
      ...(!!currencies?.length && {
        'id||$notin': currencies.map((item) => item.id),
      }),
    }),
    [record?.id, group?.id, currencies],
  );

  const handleSelectAll = useCallback(async () => {
    setAdding(true);
    try {
      const { data } = await dataProvider.getList(resourceSlug.CURRENCY, {
        pagination: {
          page: 1,
          perPage: 500, // To get all currencies
        },
        sort: {
          field: 'id',
          order: 'ASC',
        },
        filter: filters,
      });
      const object = {
        ...keyBy(currencies, 'id'),
        ...keyBy(data, 'id'),
      };
      onChange('replace', Object.values(object).reverse());
    } finally {
      setAdding(false);
    }
  }, [onChange, currencies, dataProvider, filters]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      sx={{
        gap: 4,
      }}
    >
      <Button
        size="small"
        onClick={handleSelectAll}
        className={classes.button}
        disabled={adding}
        startIcon={adding ? <CircularProgress size={20} /> : <PlaylistAdd />}
      >
        {t('resources.brand.selectAllCurrencies')}
      </Button>
      <Button
        size="small"
        startIcon={<PlaylistRemove />}
        className={clsx(classes.button, classes.error)}
        onClick={() => {
          onChange('replace', []);
        }}
        disabled={!currencies?.length}
      >
        {t('resources.brand.removeAllCurrencies')}
      </Button>
    </Box>
  );
};

export default memo(QuickAction);

const PlaylistRemove = () => (
  <svg
    className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1phnduy"
    focusable="false"
    aria-hidden="true"
    viewBox="0 0 24 24"
  >
    <path d="M14 10H3v2h11zm0-4H3v2h11zM3 16h7v-2H3zm11.41 6L17 19.41 19.59 22 21 20.59 18.41 18 21 15.41 19.59 14 17 16.59 14.41 14 13 15.41 15.59 18 13 20.59z" />
  </svg>
);

const useStyles = makeStyles((theme) => ({
  button: {
    margin: 0,
    padding: '4px 10px',
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    '&[class*="disabled"]': {
      backgroundColor: `${theme.palette.grey[100]} !important`,
    },
  },
  error: {
    color: theme.palette.error.main,
    backgroundColor: theme.palette.error[100],
    '&:hover': {
      backgroundColor: theme.palette.error[100],
    },
  },
}));
